// DWB [2026-06-02]: Easier to define errors in one place, rather than in each sub-module that relies on catalog-state.
export const MISSING_CATALOG_ERROR_MESSAGE = 'Catalog could not be loaded. Please refresh and try again.';
export const MISSING_CATALOG_ERROR_CODE = 'PM-404';
export const MISSING_CATALOG_ERROR = {
  error: {message: MISSING_CATALOG_ERROR_MESSAGE, code: MISSING_CATALOG_ERROR_CODE},
} as const;
